export const SET_COMMON_CONFIG = "SET_COMMON_CONFIG"
export const GET_GLOBAL_CONFIG = "GET_GLOBAL_CONFIG"
export const SET_MASS_CONFIG = "SET_MASS_CONFIG"